import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bfd9552"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "msg_center_wrap"
}
const _hoisted_2 = { class: "msg_center_menu" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "msg_center_item" }, "问卷报告", -1))
const _hoisted_4 = { class: "msg_center_menu_height" }
const _hoisted_5 = { class: "msg_center_tbody" }
const _hoisted_6 = { class: "questionnaire" }
const _hoisted_7 = { class: "mod_c_title questionnaire_title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "问卷报告", -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "mod_wrap mod_set_wrap mod_c" }
const _hoisted_11 = { class: "mod_c_title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "问卷报告", -1))
const _hoisted_13 = { class: "" }

import { RollbackOutlined } from '@ant-design/icons-vue';
import { ref, defineAsyncComponent, shallowRef } from 'vue';
import { Tabs, Menu, message } from 'ant-design-vue';
import Crumb from '@/components/Crumb.vue';
import http from '@/api/report';
import { useRoute } from 'vue-router';
import router from '@/router';
import { emptyDataSec } from '@/assets';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const aTabs = Tabs;
const aTabPane = Tabs.TabPane;
const aMenu = Menu;
const aMenuItem = Menu.Item;
const Overview = defineAsyncComponent(() => import('./components/Overview.vue'));
const Details = defineAsyncComponent(() => import('./components/Details.vue'));
const Analysis = defineAsyncComponent(() => import('./components/Analysis.vue'));

const activeKey = ref(0);
const tabs = shallowRef([
  {
    key: 0,
    title: '数据总览',
    component: Overview,
  },
  {
    key: 1,
    title: '数据详情',
    component: Details,
  },
  {
    key: 2,
    title: '数据分析',
    component: Analysis,
  },
]);

const route = useRoute();
const studioId = route.params.studioId; // 直播间id
let questId: any = ref(route.query.id);
const questList: any = ref([]);
const getQuestMenu = () => {
  http
    .getQuestList({ params: { studio_id: studioId } })
    .then((res) => {
      questList.value = [];
      questList.value = [...res.data.data];
      if (questList.value.length > 0) {
        selectedKeys.value = questId.value ? [Number(questId.value)] : [Number(questList.value[0].id)];
        questId.value = questId.value ? questId.value : Number(questList.value[0].id);
      }
      router.push({ name: `Questionnaire`, query: { id: questId.value } });
      route.query.id = questId.value;
    })
    .finally(() => {
      message.destroy();
    });
};
getQuestMenu();

let fullPath: any = ref();
const selectedKeys = ref<number[]>([]);
const getSelect = (e: any) => {
  questId.value = e.key;
  router.push({ name: `Questionnaire`, query: { id: questId.value } });
  route.query.id = questId.value;
  fullPath.value = `${route.path}?id=${questId.value}`;
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_unref(questId))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questList.value, (item) => {
              return (_openBlock(), _createBlock(_unref(aMenu), {
                class: "msg_center_menu_main",
                theme: "light",
                mode: "inline",
                inlineIndent: 18,
                key: item.id,
                selectedKeys: selectedKeys.value,
                "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
                onClick: getSelect
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_unref(aMenuItem), {
                    key: item.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1024))
                ]),
                _: 2
              }, 1032, ["selectedKeys"]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Crumb),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_router_link, {
                to: { path: `/market/${_unref(studioId)}/questionnairee` }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, null, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(RollbackOutlined))
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("返回列表 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            (_openBlock(), _createBlock(_component_router_view, { key: _unref(fullPath) }, {
              default: _withCtx(() => [
                _createVNode(_unref(aTabs), {
                  type: "card",
                  activeKey: activeKey.value,
                  "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((activeKey).value = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (item) => {
                      return (_openBlock(), _createBlock(_unref(aTabPane), {
                        key: item.key,
                        tab: item.title
                      }, {
                        default: _withCtx(() => [
                          (activeKey.value == item.key)
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), { key: 0 }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["tab"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ]),
              _: 1
            }))
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _createVNode(Crumb),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_router_link, {
              to: { path: `/market/${_unref(studioId)}/questionnairee` }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, null, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(RollbackOutlined))
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode("返回列表 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_a_empty, {
              class: "empty_wrap",
              image: _unref(emptyDataSec),
              description: "页面暂无数据信息~"
            }, null, 8, ["image"])
          ])
        ])
      ]))
}
}

})